import React from "react";

const StandardContext = React.createContext({SUCK_ON : "THEZE NUTZ"});

export default StandardContext;